import * as React from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { NavLink, useLocation, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { IconRoute } from './../../../../utils/Icons'

import useStyleBreadcrumbs from './useStyleBreadcrumbs'
import { entityTraducLibrary } from '../../../../utils/BreadcrumbsLibrary'

export default function BreadcrumbsComponent ({ name }) {
  const location = useLocation()
  const [route, setRoute] = useState([])
  const classes = useStyleBreadcrumbs()
  const { id } = useParams()

  const handleGetRoute = () => {
    const route = location.pathname.split('/')
    route.shift()
    route.pop()
    setRoute(route)
  }

  useEffect(() => {
    handleGetRoute()
  }, [id])

  const getRouteWithItem = (item) => {
    const result = []
    for (let index = 0; index < route.length; index++) {
      if (route[index] !== item) {
        result.push(route[index])
      } else {
        result.push(route[index])
        break
      }
    }

    return result.join('/')
  }

  return (
    <div className={classes.breadcrumbsStyle}>
      <Breadcrumbs aria-label="breadcrumb">
        {route.length > 0 &&
          route.map((item) => (
            <NavLink
              style={{ textDecoration: 'none' }}
              to={`/${getRouteWithItem(item)}`}
              key={item}
            >
              <div className={classes.linkStyle}>
                {item === id
                  ? (
                  <Typography className={classes.typography}>{name}</Typography>
                    )
                  : (
                  <>
                    {IconRoute(item)}
                    <Typography className={classes.typography}>
                      {entityTraducLibrary(item)}
                    </Typography>
                  </>
                    )}
              </div>
            </NavLink>
          ))}
        <Typography style={{ fontWeight: 700 }} color="text.primary">
          {entityTraducLibrary(location.pathname.split('/').pop())}
        </Typography>
      </Breadcrumbs>
    </div>
  )
}
